/* eslint-disable no-invalid-this */
/* eslint-disable new-cap */
import {html, nothing} from 'lit';
import {createRef, ref} from 'lit/directives/ref.js';
import {classMap} from 'lit/directives/class-map.js';
import {FacetBasic} from '../facet-basic/facet-basic';
import styles from './facet-toggle.component.scss?as=stylesheet';
import {defineCustomElement} from 'extensions/utils';

class FacetToggle extends FacetBasic {

	static get styles () {
		return [
			...super.styles,
			styles
		];
	}

	static get properties () {
		return {
			...super.properties,
			store: {
				state: true,
				type: Object
			}
		};
	}

	toggle = createRef();

	constructor () {
		super();

		/**
		 * @type {import('extensions/ring-builder/data/ring-builder-store').RingBuilderStore}
		 */
		this.store = {};
	}

	connectedCallback () {
		super.connectedCallback();
	}

	render () {
		const hasValueofOne = this.facet?.values.filter((value) => {
			// eslint-disable-next-line eqeqeq
			return value.value == 1;
		}).pop();

		if (!hasValueofOne) {
			return nothing;
		}

		const classes = {
			facet: true,
			'is-closed': this.facet.collapsed,
			[`facet-field--${this.facet.field}`]: true,
			[`facet-type--${this.facet.type}`]: true
		};

		return html`
			<div class="${classMap(classes)}">
				${this.renderFacetHeader()}
				<div class="facet--values">
					${this.renderRangeInputs()}
					${this.renderFacetValues(hasValueofOne)}
				</div>
			</div>
		`;
	}

	/**
	 * @param {import('extensions/hawksearch/services/types').FacetValue} hasValueofOne
	 */
	renderFacetValues (hasValueofOne) {
		return html`
			<input class="toggle-input" id="toggle" type="checkbox" @change="${this.handleChange}" ?checked="${hasValueofOne?.selected}" ${ref(this.toggle)}>
			<label for="toggle" class="toggle-label" aria-label="${hasValueofOne?.selected ? 'On' : 'Off'}">
				<div class="facet--option toggle-off" tabindex="${hasValueofOne?.selected ? 0 : -1}" @keypress="${this.handleKeyPress}">
				Off
				</div>
				<span class="facet--switch"></span>
				<div class="facet--option toggle-on" tabindex="${hasValueofOne?.selected ? -1 : 0}" @keypress="${this.handleKeyPress}">
				On
				</div>
			</label>
		`;
	}

	handleChange () {
		this.service.toggleFacetValue(this.facet.field, this.facetTrueValue.value);
	}

	handleKeyPress = (e) => {
		if (e.keyCode === 13) {
			this.toggle.value.checked = !this.toggle.value.checked;
			this.handleChange();
		}
	}

	get facetTrueValue () {
		return this.facet.values.find(value => value.value === 1 || value.value === '1');
	}


};

defineCustomElement('rb-facet-toggle', FacetToggle);
